import React from "react";
import Translate from "react-translate-component";
import ReactTooltip from "react-tooltip";
import utils from "common/utils";
import SettingsActions from "actions/SettingsActions";
import AccountRegistrationForm from "./AccountRegistrationForm";
import AccountRegistrationConfirm from "./AccountRegistrationConfirm";

class AccountRegistration extends React.Component {
  constructor() {
    super();
    this.state = {
      accountName: ""
    };
    this.continue = this.continue.bind(this);
    this.toggleConfirmed = this.toggleConfirmed.bind(this);
  }

  UNSAFE_componentWillMount() {
    SettingsActions.changeSetting({
      setting: "passwordLogin",
      value: true
    });
  }

  componentDidMount() {
    ReactTooltip.rebuild();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !utils.are_equal_shallow(nextState, this.state);
  }

  continue({
    accountName,
    password
  }) {
    this.setState({
      accountName,
      password,
      confirmationStep: true
    });
  }

  toggleConfirmed() {
    const {
      active
    } = this.state;
    this.setState({
      active: !active
    });
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "no-margin grid-block registration-layout registration"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid-block horizontal align-center text-center"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
      className: `model-img ${this.state.active ? "confirmed" : ""}`,
      src: "/model-type-images/account.svg",
      alt: "account"
    })), /*#__PURE__*/React.createElement("div", {
      className: "create-account-block"
    }, /*#__PURE__*/React.createElement(Translate, {
      component: "h3",
      className: "registration-account-title",
      content: "registration.createByPassword"
    }), !this.state.confirmationStep ? /*#__PURE__*/React.createElement(AccountRegistrationForm, {
      continue: this.continue
    }) : /*#__PURE__*/React.createElement(AccountRegistrationConfirm, {
      accountName: this.state.accountName,
      password: this.state.password,
      toggleConfirmed: this.toggleConfirmed,
      history: this.props.history
    }))));
  }

}

export default AccountRegistration;